<template>
  <component :is="`Dev${currentComponent.charAt(0).toUpperCase() + currentComponent.slice(1)}`" />
</template>

<script>
export default {
  name: 'DevApp',
  components: {
    DevApi: () => import('./DevApi.vue'),
    DevDates: () => import('./DevDates.vue'),
    DevTools: () => import('./DevTools.vue'),
  },
  computed: {
    currentComponent() {
      return this.$route.params.reportName || 'tools'
    },
  },
}
</script>
